import React from "react";
import "../assets/stylesheets/header.css";

import KeycloakManager from "../services/keycloak";
import { Hamburger } from "@focus/focusUI";
import {
  MenuItem,
  Popover,
  Menu,
  Button,
  Position,
  Navbar,
  NavbarGroup,
  Classes,
} from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import { store, type RootState } from "../store";
import { useRoles } from "../hooks/useRoles";
import { focusOcApps } from "./sideBarItems";
import { useSelector } from "react-redux";
import { HeaderHelpButton } from "./HeaderHelpButton";

interface HeaderProps {
  collapsed: boolean;
  onChange: () => void;
}

export const Header: React.FC<HeaderProps> = ({ collapsed, onChange }) => {
  const { roles } = useRoles();
  const config = useSelector((state: RootState) => state.appThemeConfig);
  const username = KeycloakManager.getUsername();
  const accessibleApps = focusOcApps.filter((app) =>
    app.required.some((r) => [...roles].includes(r))
  );

  return (
    <Navbar className="foc-header">
      <NavbarGroup>
        {accessibleApps.length > 0 && (
          <Hamburger collapsed={collapsed} onChange={onChange} />
        )}
      </NavbarGroup>
      <NavbarGroup className="header-content">
        {config.headerLogoLeft && (
          <div className="header-logo-wrapper header-logo-wrapper-left">
            <img
              className="header-logo"
              src={config.headerLogoLeft}
              alt="Logo left"
            />
          </div>
        )}

        {config.headerTitle && (
          <div className="header-title">{config.headerTitle}</div>
        )}

        {config.headerLogoRight && (
          <div className="header-logo-wrapper header-logo-wrapper-right">
            {(Array.isArray(config.headerLogoRight)
              ? config.headerLogoRight
              : [config.headerLogoRight]
            ).map((logoSrc, index) => (
              <img
                key={index}
                className="header-logo"
                src={logoSrc}
                alt={`Logo right ${index + 1}`}
              />
            ))}
          </div>
        )}
      </NavbarGroup>

      <NavbarGroup className={`${Classes.ALIGN_RIGHT} foc-header-actions`}>
        <HeaderHelpButton />
        <Popover
          popoverClassName="foc-header-user-popover"
          portalClassName="foc-header-user-popover-portal"
          usePortal
          content={
            <Menu className="foc-header-user-menu">
              <MenuItem
                icon="log-out"
                onClick={() => KeycloakManager.doLogout(store.dispatch)}
                text="Logout"
              />
            </Menu>
          }
          position={Position.BOTTOM_LEFT}
        >
          <Button
            className="foc-header-user-button"
            minimal
            icon="user"
            text={username}
          />
        </Popover>
      </NavbarGroup>
    </Navbar>
  );
};
